import { Loader } from 'Components';
import { useState } from 'react';

export const useLoader = (
  scale?: string,
  sx?: any,
  size?: string,
  loading?: boolean
) => {
  const loader = <Loader width={size || '50px'} />;
  const [isLoading, setIsLoading] = useState<boolean>(false);

  return { isLoading, setIsLoading, loader };
};
